<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <h3>Certificar realização dos serviços</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>

        <v-row>
          <v-col :cols="dynamicCol">
            <v-autocomplete
                v-model="IdUnidade"
                :items="unidadesList"
                item-text="Unidade"
                item-value="IdUnidade"
                label="Unidade"
                @change="[getAgendamentos($event)]"
                hide-details
                outlined
                dense
                clearable
            ></v-autocomplete>
          </v-col>
          <v-col :cols="dynamicCol">
            <v-autocomplete
                v-model="IdEmpresa"
                :items="empresasFilter"
                item-text="RazaoSocialWithCNPJ"
                item-value="IdEmpresa"
                label="Empresa"
                @change="[getAgendamentos($event)]"
                hide-details
                outlined
                dense
                clearable
            >
            </v-autocomplete>
          </v-col>
          <v-col v-can :cols="dynamicCol">
            <v-autocomplete
                v-model="IdCredenciado"
                :items="credenciadosFilter"
                item-text="Nome"
                item-value="IdProfissional"
                label="Credenciado"
                @change="[getAgendamentos($event)]"
                hide-details
                outlined
                dense
                clearable
            ></v-autocomplete>
          </v-col>
          <v-col :cols="dynamicCol">
            <v-select
                v-model="TipoFiltro"
                :items="etiquetasList"
                item-text="titulo"
                item-value="IdEtiqueta"
                label="Tipo"
                @change="[getAgendamentos($event)]"
                hide-details
                outlined
                dense
                clearable
            ></v-select>
          </v-col>
          <v-col :cols="dynamicCol">
            <v-autocomplete
                v-model="IdProcesso"
                :items="ProcessoList"
                item-text="Titulo"
                item-value="IdStatusProcesso"
                label="Situação"
                @change="[getAgendamentos($event)]"
                hide-details
                outlined
                dense
                clearable
            ></v-autocomplete>
          </v-col>
          <v-col :cols="dynamicCol">
            <v-autocomplete
                v-model="IdMes"
                :items="periodosList"
                item-text="Mes"
                item-value="IdMes"
                label="Mês"
                @change="[getAgendamentos($event)]"
                hide-details
                outlined
                dense
                clearable
            ></v-autocomplete>
          </v-col>
          <v-col :cols="dynamicCol">
            <v-select
                v-model="IdAno"
                :items="anoList"
                item-text="IdAno"
                item-value="IdAno"
                label="Ano"
                @change="[getAgendamentos($event)]"
                hide-details
                outlined
                dense
                clearable
            ></v-select>
          </v-col>
          <v-col cols="3" v-if="IdUnidade != null || IdMes != null || IdAno != null || IdProcesso!=null || TipoFiltro!=null">
            <v-btn color="primary" width="100%" v-bind:id="dynamicCol='2.4'" @click="[dynamicCol=2.4, limparFiltros()]"
                   dark>
              <span v-if="$vuetify.breakpoint.xsOnly"> Limpar </span>
              <span v-else> Limpar filtros </span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col xs="12" sm="7" md="8" lg="9" xl="10">
            <v-text-field v-model="search" prepend-icon="mdi-feature-search-outline" label="Pesquisar" clearable></v-text-field>
          </v-col>
          <v-col xs="12" sm="5" md="4" lg="3" xl="2">
            <v-btn block color="primary" class="mt-3" @click="[modalPeriodoRelatorioServico = true]" dark>
              <v-icon left>mdi-file-document</v-icon>
              Gerar relatório
            </v-btn>
          </v-col>

        </v-row>
        <v-data-table
            :headers="headersAgendamentos"
            :items="agendamentos"
            :search="search"
            class="elevation-1"
            :loading="myloadingvariable"
            :expanded.sync="expanded"
            item-key="IdAgendamento"
            show-expand
            single-expand            
            loading-text="Carregando..."
        >
          <template v-slot:[`item.dataInicial`]="{ item }">
            {{$moment(item.dataInicial).format('L')}}
          </template>
          <template v-slot:[`item.statusProcesso`]="{ item }">
            <StatusProcesso :status="item"></StatusProcesso>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <OcorrenciasProcesso :IdAgendamento="item.IdAgendamento"></OcorrenciasProcesso>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on"
                       :disabled="item.contarEstatistica == 0 ? true : false || item.IdStatusProcesso >= 2 ? false : true"
                       icon @click="[getServicosAnexos(item.IdAgendamento)]">
                  <v-icon>mdi-file-eye</v-icon>
                </v-btn>
              </template>
              <span>visualizar anexos</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color=orange :disabled="!item.faturamento" icon @click="[dialogQuantidadeExecutada = true, getServicos(item.IdAgendamento)]">
                  <v-icon>mdi-check-all</v-icon>
                </v-btn>
              </template>
              <span>certificar quantidade executada</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" color=green v-on="on" :disabled="item.contarEstatistica == 0 ? true : false || item.IdStatusProcesso >= 2 ? false : true" icon @click="[diagProfissionais = true, getServicos(item.IdAgendamento), getIdEmpresa(item.IdEmpresa), getTiposAnexos(), funcionarios = []]">
                  <v-icon>mdi-account-multiple-plus</v-icon>
                </v-btn>
              </template>
              <span>registrar participantes</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" color=primary v-on="on" v-if="item.IdStatusProcesso <= 3" icon
                  @click="[enviarNucleoView = true, getServicos(item.IdAgendamento)]"
                >
                  <v-icon>mdi-skip-forward</v-icon>
                </v-btn>
              </template>
              <span>enviar para o núcleo</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" color=red v-on="on" v-if="item.IdStatusProcesso == 4" icon
                  @click="[resgatarNucleoView = true, getServicos(item.IdAgendamento)]"
                >
                  <v-icon>mdi-skip-backward</v-icon>
                </v-btn>
              </template>
              <span>resgatar do núcleo</span>
            </v-tooltip>

          </template>

          <template v-slot:expanded-item="{ item }">
            <td colspan="12" style="padding: 10px">
              <v-data-table
                :headers="headersOcorrencias"
                :items="item.ocorrencias"
                :loading="loading"
                loading-text="Carregando..."
                class="elevation-0"
                hide-default-footer
                disable-pagination
              >
                  <template v-slot:[`item.DataOcorrencia`]=" { item } ">
                    {{ $moment(item.DataOcorrencia).format('L LT') }}
                  </template>
              </v-data-table>
            </td>
          </template>
          
        </v-data-table>
      </v-card-text>
    </v-card>
    <AlertSystem :snackbar="system.snackbar"></AlertSystem>

    <!-- Registro dos participantes - listar os servicos do agendamento -->

    <v-dialog width="80%" scrollable v-model="diagProfissionais" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card flat :loading="myloadingvariable">
        <v-card-title>
          Registro dos participantes
          <v-spacer></v-spacer>
          <v-btn icon @click="[diagProfissionais = false, fecharModal()]">
            <v-icon>mdi-close-box</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-8 pt-2 pb-0" v-if="servicos !=null" >
          <v-row>
            <template>
              <strong>CNPJ: {{servicos[0].CNPJ}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Razão Social: {{servicos[0].RazaoSocial}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Titulo: {{servicos[0].titulo}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Data: {{`${$moment(servicos[0].DataInicial).format('L')}`}} </strong>
            </template>
          </v-row>
        </v-card-text>
        <v-card-text>
          <v-row v-if="dadosEmpresa != null">
            <v-col cols="10" class="ml-5">
              <p class="font-weight-black title">{{dadosEmpresa.RazaoSocial}}</p>
              <p class="font-weight-regular subtitle-1">CNPJ: {{dadosEmpresa.CNPJ}}</p>
              <p class="font-weight-regular subtitle-1">Título: {{servicos[0].titulo}}</p>
              <p class="font-weight-regular subtitle-1">Data: {{`${$moment(servicos[0].DataOcorrencia).format('L')}`}}</p>
            </v-col>
          </v-row>
          <v-tabs v-if="servicos != null" :grow="true" v-model="tab">
            <template v-for="servico in servicos">
              <v-tab v-if="servico.IdProcedimento != 818 && servico.ServicoCertificado == 1" :key="servico.IdProcedimento" @click="[getExecucoes(servico.IdAgendamentoServico, servico.IdAgendamento), reloadFuncionarios(servico.IdAgendamentoServico)]">{{servico.Procedimento}} ({{servico.quantidadeCertificada}}/{{servico.quantidadeExecutada}})</v-tab>
            </template>
          </v-tabs>
          <v-tabs-items v-if="servicos != null" v-model="tab">
            <v-tab-item v-for="servico in servicos" :key="servico.IdProcedimento">
              <v-card flat>
                <v-card-title>
                  <v-col xs="12" sm="5" md="8" lg="8" xl="9">
                    <v-text-field
                        v-model="searchExecucoes"
                        prepend-icon="mdi-magnify"
                        label="Pesquisar"
                    ></v-text-field>
                  </v-col>
                  <v-col xs="12" sm="7" md="4" lg="4" xl="3">
                    <v-btn block dark color="primary" @click="[anexosTipo = null ,addParticipantesView = !addParticipantesView, getFuncionarios()]">
                      <v-icon left>mdi mdi-plus</v-icon>Participantes do serviço
                    </v-btn>
                  </v-col>
                </v-card-title>

                <v-card-text v-show="existemExecucoes">
                  <v-data-table
                      :headers="headersExecucoes"
                      :items="execucoes"
                      :search="searchExecucoes"
                      class="elevation-1"
                      :loading="myloadingvariable"
                      loading-text="Carregando..."
                  >
                    <template v-slot:[`item.DataNascimento`]="{ item }">
                      {{ $moment(item.DataNascimento).format('L') }}
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog width="40%" v-model="modalPeriodoRelatorioServico">
      <v-card>
        <v-card-title>Gerar relatório</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-menu
                  v-model="menuDataInicial"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="dataInicialRelatorio"
                      label="Data Inicial"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      type="date"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dataInicialRelatorio" @input="menuDataInicial = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                  v-model="menuDataFinal"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="dataFinalRelatorio"
                      label="Data Final"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      type="date"
                  ></v-text-field>
                </template>
                <v-date-picker :min="dataInicialRelatorio" v-model="dataFinalRelatorio" @input="menuDataFinal = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary"
                  :loading="loadRelatorio"
                  @click="[loader = 'loading', gerarRelatorio()]"
                  dark
          >
            Gerar relatório
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Registro dos participantes - apos selecionar o servico -->

    <v-dialog width="90%" scrollable v-model="addParticipantesView" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card flat :loading="loadAnexos">
        <v-card-title class="mb-0">
          <v-spacer></v-spacer>
          <v-btn icon @click="[addParticipantesView = false, files = null, tab = null, selected = [], getServicos(reloadIdAgendamento)]">
            <v-icon>mdi-close-box</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row v-if="dadosEmpresa != null">
            <v-col cols="10" class="ml-5">
              <p class="font-weight-black title">{{dadosEmpresa.RazaoSocial}}</p>
              <p class="font-weight-regular subtitle-1">{{dadosEmpresa.CNPJ}}</p>
            </v-col>
          </v-row>
          <!-- Esconder as tabs por falta de usabilidade, definir como será -->
          <!-- <v-tabs :grow="true" v-model="tab">
            <v-tab v-for="servico in servicos" :key="servico.index">{{servico.Procedimento}}</v-tab>
          </v-tabs> -->
          <v-alert v-if="system.alertError" v-model="system.alertError" dismissible type="error">
            <ul>
              <li v-for="error in system.alertInfo" :key="error.index">{{error[0]}}</li>
            </ul>
          </v-alert>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="(servico, servicoIndex) in servicos" :key="servicoIndex">
              <v-card class="pa-2 pt-0" flat>
                <v-card-title>
                  Gerenciar registro dos participantes
                  <v-spacer></v-spacer>
                  <v-btn :loading="loadAnexos" dark color="primary" @click="[anexarArquivos(IdAgendamentoServico)]">
                    <v-icon left>mdi-account-multiple-plus</v-icon>Anexar evidências
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="10">
                      <v-file-input small-chips show-size multiple label="Anexos" ref="files" v-model="files"></v-file-input>
                    </v-col>
                    <v-col cols="2">
                      <v-autocomplete v-model="anexosTipo" :items="tiposAnexosList" item-value="IdTipo" item-text="Tipo" label="Tipo de anexo"></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-chip
                        v-for="(item, i) in servico.anexos" :key="i"
                        class="ma-2"
                        close
                        color="primary"
                        outlined
                        @click:close="deletarAnexo(servicoIndex, item.id)"
                    >
                      <v-icon left>mdi-file-pdf</v-icon>
                      {{ item.originalName }}
                    </v-chip>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field v-model="searchFuncionariosAdd" prepend-icon="mdi-account-multiple" label="Pesquisar"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-data-table
                      v-model="selected"
                      :headers="headersFuncionariosAdd"
                      :items="funcionarios"
                      :search="searchFuncionariosAdd"
                      :single-select="singleSelect"
                      :items-per-page="itemsPerPage"
                      :page.sync="page"
                      hide-default-footer
                      item-key="IdCliente"
                      :show-select="showSelect"
                      @toggle-select-all="removeAll"
                      @input="selectAll(IdAgendamentoServico)"
                      @item-selected="[singleSelected(IdAgendamentoServico)]"
                      class="elevation-1"
                      @page-count="pageCount = $event"
                      :loading="loadTable">
                    <template v-slot:[`item.Registrado`]="{ item }">
                      <v-chip v-if="item.Registrado==1" color="green" dark>Registrado</v-chip>
                      <v-chip v-else color="orange" dark>Não registrado</v-chip>
                    </template>
                    <template v-slot:[`item.DataNascimento`]="{ item }">
                      {{ $moment(item.DataNascimento).format('L') }}
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-on="on" v-bind="attrs" icon @click="OneUserAllServices(item)">
                            <v-icon>
                              mdi-account-multiple-check-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Registrar o funcionário em todos os serviços</span>
                      </v-tooltip>
                      <v-menu
                        open-on-click
                        bottom
                        offset-y
                        :close-on-content-click="false"
                      >
                        <template v-slot:activator="{ on: menu, attrs }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on: tooltip }">
                              <v-btn
                                icon
                                v-bind="attrs"
                                v-on="{ ...tooltip, ...menu }">
                                <v-icon>
                                  mdi-format-list-checkbox
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Registrar o funcionário em serviços específicos</span>
                          </v-tooltip>
                        </template>
                        <v-list>
                          <v-list-item
                            @click="OneUserAllServices(item)"
                          >
                            <v-list-item-content>
                              Adicionar a todos
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item
                            v-for="(i, index) in servicosTratados"
                            :key="index"
                            @click="OneUserToService(i, item)"
                            active-class="primary--text text--accent-4"
                          >
                            <v-list-item-content>
                              <v-list-item-title>{{ i.Procedimento }}</v-list-item-title>
                              <!-- <v-list-item-subtitle v-if="itemsContains(item.IdAgendamentoServico)">X</v-list-item-subtitle> -->
                            </v-list-item-content>
                            <v-list-item-icon>
                              <v-icon v-if="itemsContains(i.IdAgendamentoServico, funcionarios.indexOf(item))" color="green">mdi-check</v-icon>
                            </v-list-item-icon>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-data-table>
                  <div class="text-center pt-4">
                    <v-pagination
                        v-model="page"
                        :length="pageCount"
                    ></v-pagination>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Anexos dos procedimentos -->

    <v-dialog width="60%" scrollable v-model="dialogServicosAnexos" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card flat>
        <v-card-title>
          Gerenciar anexos do agendamento
          <v-spacer></v-spacer>
          <v-btn icon @click="[dialogServicosAnexos = false, fecharModal()]">
            <v-icon>mdi-close-box</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-8 pt-2 pb-0" v-if="servicos !=null" >
          <v-row>
            <template>
              <strong>CNPJ: {{servicos[0].CNPJ}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Razão Social: {{servicos[0].RazaoSocial}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Titulo: {{servicos[0].titulo}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Data: {{`${$moment(servicos[0].DataInicial).format('L')}`}} </strong>
            </template>
          </v-row>
        </v-card-text>
        <v-card-text class="mb-0 pb-0">
          <v-tabs :grow="true" v-model="tab" v-if="servicos!=null">
            <template v-for="servico in servicos">
              <v-tab v-if="servico.IdProcedimento != 818 && servico.ServicoCertificado" :key="servico.index" @click="getAnexos(servico.IdAgendamentoServico)">{{servico.Procedimento}} ({{servico.quantidadeCertificada}}/{{servico.quantidadeExecutada}})</v-tab>
            </template>
          </v-tabs>
          <div v-if="qtdAnexos > 0" class="pl-0 pt-2 pb-0 mb-0">
            <template class="mb-0">
              <v-alert
                  v-for="ocorrencia in ocorrencias"
                  :key="ocorrencia.index"
                  color="primary"
                  dark
                  dense
              >
                <v-row align="center">
                  <v-col xl="9" lg="9" md="8" sm="6" xs="12">
                    {{ ocorrencia.originalName }} : {{`${$moment(ocorrencia.created_at).format('L')}`}}
                  </v-col>
                  <v-col xl="3" lg="3" md="4" sm="6" xs="12">
                    <v-btn
                        color="white primary--text"
                        @click="acessarEvidencia(ocorrencia.IdAgendamentoServico, `${$moment(ocorrencia.created_at).format('YYYY-MM-DD HH:mm:ss')}`)"
                    >
                      Download
                      <v-icon
                          right
                          dark
                      >
                        mdi-download
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-alert>
            </template>
          </div>
        </v-card-text>
        <v-card-text class="pa-0 ma-0">
          <v-alert
              v-if="qtdAnexos === 0"
              color="primary"
              class="ml-6 mr-6"
              dark
              icon="mdi-alert"
              prominent
          >
            Não há anexos para esse serviço ainda
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Certificar a quantidade executada em cada servico -->

    <v-dialog width="70%" v-model="dialogQuantidadeExecutada" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card :loading="myloadingvariable">
        <v-card-title class="text-h6 grey lighten-2">
          Certificar a realização dos serviços
          <v-spacer></v-spacer>
          <v-btn icon @click="[dialogQuantidadeExecutada = false, fecharModal()]">
            <v-icon>mdi-close-box</v-icon>
          </v-btn>          
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-8 pt-4 pb-4" v-if="servicos !=null" >
          <v-row>
            <template>
              <strong>Empresa: {{servicos[0].CNPJ}} - {{servicos[0].RazaoSocial}}</strong>
            </template>
          </v-row>          
          <v-row>
            <template>
              <strong>Titulo: {{servicos[0].titulo}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Data da visita: {{`${$moment(servicos[0].DataInicial).format('L')}`}} </strong>
            </template>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="pt-2 pb-4">
          <v-row v-for="(servico, index) in servicos" :key="index">
            <v-row v-if="servico.IdProcedimento != 818">
              <v-col cols="7" class="pt-8">
                <strong>{{ servico.Procedimento }}</strong>
              </v-col>
              <v-col cols="5">
                <v-row>
                  <v-col cols="4">
                    <span v-if="servico.quantidadePessoas > 0">
                        <br/>Agendado: {{servico.quantidadePessoas}}
                    </span>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field 
                      v-if="servico.IdProcedimento != 818" 
                      :disabled="(servico.FaturarServico == 0 && servico.contarEstatistica == 1 ? false : true) && servico.FaturarServico == 0 ? true : false" 
                      v-model="cadQuantidadeExecutada[index].quantidadeExecutada"
                      label="Realizado:">
                      <template #append>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" @click="[
                                    cadQuantidadeExecutada[index].quantidadeExecutada = cadQuantidadeExecutada[index].quantidadeExecutadaSugestao,
                                    cadQuantidadeExecutada[index].certificar = 1]">
                                mdi-lightbulb-on
                              </v-icon>
                            </template>
                            Quantidade executada: {{ cadQuantidadeExecutada[index].quantidadeExecutadaSugestao }} serviços
                          </v-tooltip>
                        </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-checkbox v-model="cadQuantidadeExecutada[index].certificar"
                      :disabled="servico.ServicoCertificado == 1 ? true : false"
                      :label="servico.ServicoCertificado == 1 ? 'Certificado' : 'Certificar'">
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogQuantidadeExecutada = !dialogQuantidadeExecutada" large dark>
            cancelar
          </v-btn>
          <v-btn :loading="myloadingvariable" @click="cadastrarQuantidadeExecutada()" color="primary" large dark>
            Certificar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="50%" v-model="nucleoDialog" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card :loading="myloadingvariable">
        <v-card-title class="text-h6 grey lighten-2">
          Enviar/resgatar para núcleo de produção
          <v-spacer></v-spacer>
          <v-btn icon @click="[enviarNucleoView = false, resgatarNucleoView == false]">
            <v-icon>mdi-close-box</v-icon>
          </v-btn>          
        </v-card-title>        
        <v-divider></v-divider>
        <v-card-text class="pa-9 pt-4 pb-2" v-if="servicos !=null" >
          <v-row>
            <template>
              <strong>Empresa: {{servicos[0].CNPJ}} - {{servicos[0].RazaoSocial}}</strong>
            </template>
          </v-row>          
          <v-row>
            <template>
              <strong>Titulo: {{servicos[0].titulo}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Data: {{`${$moment(servicos[0].DataInicial).format('L')}`}} </strong>
            </template>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-textarea v-model="justificativa"
                      auto-grow
                      label="Justificativa"
          ></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn large dark @click="enviarNucleoView = false; resgatarNucleoView = false">
            cancelar
          </v-btn>

          <v-btn
              v-if="enviarNucleoView"
              :loading="myloadingvariable"
              color="primary"
              large dark
              @click="enviarNucleo(servicos[0].IdAgendamento)"
          >
            enviar para o núcleo
          </v-btn>
          <v-btn
              v-if="resgatarNucleoView"
              :loading="myloadingvariable"
              color="primary"
              large dark
              @click="resgatarNucleo(servicos[0].IdAgendamento)"
          >
            resgatar do núcleo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import AlertSystem from "../components/AlertSystem.vue";
import StatusProcesso from "../components/StatusProcesso.vue";
import OcorrenciasProcesso from "../components/OcorrenciasProcesso.vue";
import moment from "moment";
export default {
  name: "Certificacao",
  components: {
    AlertSystem,
    StatusProcesso,
    OcorrenciasProcesso
  },
  data: () => ({
    itemsTeste: [2, 858],
    system: {
      snackbar: {},
      alertInfo: [],
      alertError: false,
      eviarNucleo: true
    },
    headersAgendamentos: [
      { text: "CNPJ", value: "CNPJ", width: "12%" },
      { text: "Razão Social", value: "RazaoSocial", width: "15%" },
      { text: "Contrato", value: "NumeroContrato", width: "9%" },
      { text: "Unidade", value: "Unidade", width: "10%" },
      { text: 'Título', value: 'titulo', width: "18%" },
      { text: "Data", value: "dataInicial", width: "10%" },
      { text: "Situação", value: "statusProcesso", width: "10%", align: 'center' },
      { text: "Ações", value: "actions", width: "15%", align: 'center' }
    ],
    headersOcorrencias: [            
      { text: "Data do registro", value: "DataOcorrencia", width: "20%" },
      { text: "Descrição da ocorrência", value: "Descricao" },      
    ],    
    headersExecucoes: [
      { text: "Matrícula", value: "IdCliente", align: "center" },
      { text: "Nome", value: "Nome" },
      { text: "CPF", value: "CPF" },
      { text: "Data de Nascimento", value: "DataNascimento", align: "center" }
    ],
    headersFuncionariosAdd: [
      { text: "Matrícula", value: "IdCliente", align: "center" },
      { text: "Nome", value: "nome" },
      { text: "CPF", value: "CPF", align: "center" },
      { text: "RG", value: "RGNumero", align: "center" },
      { text: "Data de Nascimento", value: "DataNascimento", align: "center" },
      { text: "Situação", value: "Registrado", align: "center", width: "15%"},
      { text: "Mais ações", value: "actions", align: "center", width: "10%"}
    ],
    IdCredenciado: null,
    justificativa: null,
    enviarNucleoView: false,
    resgatarNucleoView: false,
    IdEmpresa: '',
    IdAgendamentoServico: '',
    IdAgendamento: '',
    addParticipantesView: false,
    checked: [],
    selected: [],
    singleSelect: false,
    showSelect: true,
    loadTable: false,
    funcionariosRegistrados: [],
    arrayAnterior: [],
    arrayAcao: [],
    selectedAuxiliar: [],
    arrayRemocao: [],
    arrayRemocaoClientes: [],
    reloadIdAgendamento: null,
    reloadIdServico: null,
    itemsPerPage: 10,
    page: 1,
    pageCount: 0,
    quantidadeServicoPessoa: [],
    quantidadeExecutada: 0,
    search: "",
    searchExecucoes: "",
    searchFuncionarios: "",
    searchFuncionariosAdd: "",
    arrayFinal:[],
    TipoFiltro: null,
    agendamentos: [],
    servicos: null,
    IdProcesso: null,
    dataInicialRelatorio: '',
    dataFinalRelatorio: '',
    menuDataInicial: false,
    menuDataFinal: false,
    loadRelatorio: false,
    ocorrencias: null,
    qtdAnexos: 0,
    dadosEmpresa: null,
    existemExecucoes: false,
    execucoes: [],
    ProcessoList:[],
    funcionarios: [],
    etiquetasList: [],
    diagProfissionais: false,
    myloadingvariable: false,
    IdUnidade: null,
    unidadesList: [],
    servicosTratados: [],
    credenciadosFilter: [],
    empresasFilter: [],
    IdMes: null,
    loadAnexos: false,
    periodosList: [
      {
        IdMes: 1,
        Mes: 'Janeiro'
      },
      {
        IdMes: 2,
        Mes: 'Fevereiro'
      },
      {
        IdMes: 3,
        Mes: 'Março'
      },
      {
        IdMes: 4,
        Mes: 'Abril'
      },
      {
        IdMes: 5,
        Mes: 'Maio'
      },
      {
        IdMes: 6,
        Mes: 'Junho'
      },
      {
        IdMes: 7,
        Mes: 'Julho'
      },
      {
        IdMes: 8,
        Mes: 'Agosto'
      },
      {
        IdMes: 9,
        Mes: 'Setembro'
      },
      {
        IdMes: 10,
        Mes: 'Outubro'
      },
      {
        IdMes: 11,
        Mes: 'Novembro'
      },
      {
        IdMes: 12,
        Mes: 'Dezembro'
      }
    ],
    IdAno: moment().format('YYYY'),
    anoList: [
      {
        IdAno: moment().format('YYYY'),
      },
      //ano anterior
      {
        IdAno: moment().format('YYYY')-1,
      }
    ],
    dynamicCol: 1.7,
    tab: null,
    modalPeriodoRelatorioServico: false,
    // Anexos
    files: null,
    dialogServicosAnexos: false,
    dialogQuantidadeExecutada: false,
    cadQuantidadeExecutada: {
      IdAgendamento: Number,
      IdAgendamentoServico: Number,
      IdServico: Number,
      quantidadeExecutada: Number,
      certificar: Boolean
    },
    tiposAnexosList: [],
    anexosTipo: ''
  }),
  computed: {
    quantidadeExecutadaValida() {
      for (var i = 0; i < this.cadQuantidadeExecutada.length; i++) {
        if ((this.cadQuantidadeExecutada[i].quantidadeExecutada == null
          || this.cadQuantidadeExecutada[i].quantidadeExecutada <= 0
          || this.cadQuantidadeExecutada[i].quantidadeExecutada > this.servicos[i].quantidadePessoas)
          && (this.cadQuantidadeExecutada[i].certificar == 1)) {
          return false
        }
      }
      return true;
    },
    nucleoDialog() {
      return this.resgatarNucleoView || this.enviarNucleoView;
    }
  },
  methods: {
    itemsContains(service, position) {
      return this.funcionarios[position].userServices.indexOf(service) > -1
    },
    getUnidades() {
      this.axios('unidades').then(res => {
        this.unidadesList = res.data
      })
    },
    getTiposAnexos () {
      this.tiposAnexosList = []
      this.axios.get('anexos/tipos').then( res => {
        this.tiposAnexosList = res.data
      })
    },
    getAgendamentos () {
      this.myloadingvariable = true;
      this.axios
          .get("agendamentos",{
            params:{
              IdUnidade:      this.IdUnidade,
              IdEmpresa:      this.IdEmpresa,
              IdCredenciado:  this.IdCredenciado,
              IdMes:          this.IdMes,
              IdAno:          this.IdAno,
              IdProcesso:     this.IdProcesso,
              IdEtiqueta:     this.TipoFiltro,
            }
          })
          .then(res => {
            this.agendamentos = res.data.filter(agendamento => {
              agendamento.RazaoSocial = this.prepareNameFilter(agendamento.RazaoSocial);
              agendamento.titulo = this.prepareNameFilter(agendamento.titulo);

              if (agendamento.IdStatusProcesso <= 4) {
                return {
                  agendamento
                };
              }
            })
          })
          .catch(e => {
            alert(e);
          })
          .finally(() => {
            this.myloadingvariable = false;
          });
    },
    getFuncionarios() {
      this.myloadingvariable = true
      this.loadTable = true
      this.axios
          .get(`empresas/${this.IdEmpresa}/funcionariosExecucao/${this.IdAgendamentoServico}`)
          .then(res => {
            this.quantidadeServicoPessoa = []
            //Montando array para setar a quantidade de procedimentos por funcionário
            // Esse array é montado para o v-model dos componentes tex-field que informam as quantidades
            this.funcionariosRegistrados = []
            this.selected = []
            for(var i = 0; i < res.data.length; i++){
              this.quantidadeServicoPessoa.push(
                  {
                    IdCliente: res.data[i].IdCliente,
                    IdTipoCliente: res.data[i].IdTipoCliente,
                    quantidade: 1
                  }
              )
              if(res.data[i].quantidade != null){
                this.selected.push({
                  IdCliente: res.data[i].IdCliente,
                  IdTipoCliente: res.data[i].IdTipoCliente
                })
                this.funcionariosRegistrados.push(res.data[i].IdCliente)
              }
              // res.data[i].quantidade == null ? 0 : this.selected.push(res.data[i].IdCliente)

            }
            this.funcionarios = res.data;
          })
          .catch(() => {
          })
          .finally(() => {
            this.myloadingvariable = false
            this.showSelect = true
            this.loadTable = false
          });

      // chamando rota que não faz absolutamente nada
      // this.axios
      //     .get(`empresas/${this.IdEmpresa}`)
      //     .then(() => {
      //     })
      //     .catch(() => {
      //     })
      //     .finally(() => {
      //       this.myloadingvariable = false;
      //     });
    },
    reloadFuncionarios (IdAgendamentoServico) {
      this.IdAgendamentoServico = IdAgendamentoServico
      //this.getFuncionarios(this.IdEmpresa)
    },
    enviarNucleo (IdAgendamento) {
      this.axios.put(`agendamentos/${IdAgendamento}/enviarnucleo`, {
        justificativa: this.justificativa
      }).then(res => {
        this.system.snackbar = {
          snackbar: true,
          text: res.data,
          color: "green",
        };
        this.getAgendamentos()
        this.enviarNucleoView = false
        this.justificativa = null
      }).catch(error => {
        this.system.snackbar = {
          snackbar: true,
          text: error.response.data,
          color: "red",
        };
      })
    },
    resgatarNucleo (IdAgendamento) {
      this.axios.put(`agendamentos/${IdAgendamento}/resgatarnucleo`, {
        justificativa: this.justificativa
      }).then(res => {
        this.system.snackbar = {
          snackbar: true,
          text: res.data,
          color: "green",
        };
        this.getAgendamentos()
        this.resgatarNucleoView = false
        this.justificativa = null
      }).catch(error => {
        this.system.snackbar = {
          snackbar: true,
          text: error.response.data,
          color: "red",
        };
      })
    },
    getIdEmpresa (IdEmpresa){
      this.IdEmpresa = IdEmpresa
      // get empresa
      this.axios(`empresas/${this.IdEmpresa}`)
          .then( res => {
        this.dadosEmpresa = res.data.filter((empresa) => {
          empresa.RazaoSocial = this.prepareNameFilter(empresa.RazaoSocial);
          return empresa;
        })
      })
    },
    // Primeiro método chamado para certificar um agendamento
    getServicos(IdAgendamento) {
      this.servicosTratados = []
      this.myloadingvariable = true;
      this.axios
        .get(`agendamentos/${IdAgendamento}/servicos`)
        .then(res => {
          this.servicos = res.data
          this.servicosTratados = this.servicos.filter(function (el) {
            return el.IdServico != 818 && el.quantidadeExecutada > 0
          }).map(function (elem) {
              return {
                IdAgendamento: elem.IdAgendamento,
                IdAgendamentoServico: elem.IdAgendamentoServico,
                IdServico: elem.IdServico,
                Procedimento: elem.Procedimento,
                certificar: elem.ServicoCertificado
              }
          })
          this.cadQuantidadeExecutada = res.data.map( element => {
            if(element.IdAgendamento == IdAgendamento){
              return {
                IdAgendamento: IdAgendamento,
                IdAgendamentoServico: element.IdAgendamentoServico,
                IdServico: element.IdServico,
                quantidadeExecutada: element.quantidadeExecutada,
                quantidadeExecutadaSugestao: element.quantidadePessoas,
                certificar: element.ServicoCertificado
              }
            }
          })

          this.tab = 0
          // Se for ASO.
          if(res.data[0].IdServico == 818){
            this.reloadIdAgendamento = res.data[1].IdAgendamento
            this.reloadIdServico = res.data[1].IdServico

            for(let j=0; j < res.data.length; j++){
              if(res.data[j].IdServico != 818 && res.data[j].IdAgendamentoServico){
                var IdAgendServ = res.data[j].IdAgendamentoServico
                break
              }
            }

            this.getExecucoes(IdAgendServ, res.data[1].IdAgendamento);
            this.IdAgendamentoServico = res.data[1].IdAgendamentoServico
          }else{
            this.reloadIdAgendamento = res.data[0].IdAgendamento
            this.reloadIdServico = res.data[0].IdServico
            this.getExecucoes(res.data[0].IdAgendamentoServico, res.data[0].IdAgendamento);
            this.IdAgendamentoServico = res.data[0].IdAgendamentoServico
            this.certificar = 0
          }

          //this.getFuncionarios()
          for(var i=0;i<res.data.length;i++){
            if(this.servicos[i].quantidadeExecutada==null){
              this.servicos[i].quantidadeExecutada = 0;
            }
          }
        })
        .catch(() => {
        })
        .finally(() => {
          this.myloadingvariable = false;
        });
    },
    forceFileDownload(response, title) {
      const [url, link] = [window.URL.createObjectURL(new Blob([response.data])), document.createElement('a')]
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    },

    acessarEvidencia(idAgendamento, DataOcorrencia){
      this.axios.get(`agendamentos/${idAgendamento}/evidencias/${DataOcorrencia}`,{
        responseType: 'arraybuffer'
      }).then((res) => {
        this.forceFileDownload(res, DataOcorrencia + '.pdf')
      })
    },

    getAnexos(idAgendamento){
      this.axios.get(`execucoes/evidencias/${idAgendamento}`)
        .then(res => {
          this.ocorrencias = res.data
          this.qtdAnexos = res.data.length
        }
      )
    },
    getEtiquetas() {
      this.axios("etiquetas").then((res) => {
        this.etiquetasList = res.data;
      });
    },
    cadastrarQuantidadeExecutada () {
      this.myloadingvariable = true
      let IdAgendamento = this.cadQuantidadeExecutada[0].IdAgendamento

      this.axios.patch(`servicos/${IdAgendamento}/execucoes`, {
        cadQuantidadeExecutada: this.cadQuantidadeExecutada
      }).then( res => {
        this.system.snackbar = {
          snackbar: true,
          text: res.data,
          color: "green",
        };
        this.servicos = null
        this.getAgendamentos()
      }).catch(error => {
        // clearInterval
        this.system.snackbar = {
          snackbar: true,
          text: error.response.data,
          color: "red",
        };
      }).finally( () => {
        this.dialogQuantidadeExecutada = false
        this.myloadingvariable = false
      })
    },
    getServicosAnexos(IdAgendamento) {
      // this.getServicos(IdAgendamento)
      this.myloadingvariable = true;
      this.axios
        .get(`agendamentos/${IdAgendamento}/servicos`)
        .then(res => {
          this.servicos = res.data
          this.cadQuantidadeExecutada = res.data.map( element => {
            if(element.IdAgendamento == IdAgendamento){
              return {
                IdAgendamento: IdAgendamento,
                IdAgendamentoServico: element.IdAgendamentoServico,
                IdServico: element.IdServico,
                quantidadeExecutada: element.quantidadeExecutada,
                certificar: element.ServicoCertificado
              }
            }
          })
          if(res.data[0].IdServico != 818) {
            this.IdAgendamentoServico = res.data[0].IdAgendamentoServico;
          }else{
            for(let j=0; j < res.data.length; j++){
              if(res.data[j].IdServico != 818 && res.data[j].IdAgendamentoServico){
                var IdAgendServ = res.data[j].IdAgendamentoServico
                break
              }
            }
            this.IdAgendamentoServico = IdAgendServ
          }
          this.tab = 0
          this.getAnexos(this.IdAgendamentoServico)
        })
        .finally(() => {
          this.myloadingvariable = false;
          if (this.dialogServicosAnexos == false) {
            this.dialogServicosAnexos = true;
          }
        });
    },
    deletarAnexo(servicoIndex, id) {
      let con = confirm('Deseja deletar esse anexo?')
      if(con) {
        this.servicos[servicoIndex].anexos = this.servicos[servicoIndex].anexos.filter(anexo => anexo.id !== id)
        this.axios.delete(`servicos/anexos/${id}`)
            .then(() => {
              this.getServicos(this.IdAgendamento)
            })
      }
    },
    //o IdAgendamento no primeiro carregamento está undefined e por isso não
    //carrega execuções, então chamei a antiga rota que faz a mesma coisa por enquanto

    //CORRIGIDO
    //Método chamado dentro de getServicos
    getExecucoes(IdAgendamentoServico, IdAgendamento) {
      this.IdAgendamento = IdAgendamento
      this.myloadingvariable = true;
      this.axios
          .get(`agendamentos/${IdAgendamento}/servicos/${IdAgendamentoServico}/execucoes`)
          .then(res => {
            this.execucoes = res.data
            this.existemExecucoes = true
          })
          .catch(() => {
            this.existemExecucoes = false;
            // alert(e.response.data)
          })
          .finally(() => {
            this.myloadingvariable = false;
          });
    },
    removeAll (){
      this.arrayRemocao = this.selected
      for(var i = 0; i < this.selected.length; i++){
        this.arrayAnterior.push(this.selected[i].IdCliente)
      }
    },
    selectAll (IdAgendamentoServico) {
      this.showSelect = false
      this.loadTable = true

      if(this.addParticipantesView==true) {
        // transformar em array simples para usar o includes - remoção só precisa de IdCliente e IdAgendamentoServico
        for (var i = 0; i < this.selected.length; i++) {
          this.selectedAuxiliar.push(this.selected[i].IdCliente)
        }

        //zerar array de remocao
        if(this.funcionariosRegistrados.length<=this.selected.length){
          this.arrayRemocao = []
        }

        // só entra nesse IF APENAS no cenário que ainda não há certificações e usuário inseriu uma
        // TODO: Verificar do porque esse trecho de código estava enviando uma requisição para o back-end ao abrir o modal.
        if (this.arrayAnterior.length == 0 && this.selected.length == 1 && this.funcionariosRegistrados.length < 1) {
          this.arrayAcao.push({
            IdCliente: this.selected[0].IdCliente,
            IdTipoCliente: this.selected[0].IdTipoCliente
          })
          this.cadastrar(IdAgendamentoServico)
          this.funcionariosRegistrados = 1
        }

        if (this.arrayAnterior.length > 0) {
          // esse IF é para cadastros select-all e single-select ou remoções que não seja remove-all
          if (this.arrayAnterior.length > this.selectedAuxiliar.length && this.arrayRemocao.length == 0){
            // se numero de checkbox antigo > numero de checkbox atual = significa que alguém foi removido
            for (var n = 0; n < this.arrayAnterior.length; n++) {
              if (this.selectedAuxiliar.includes(this.arrayAnterior[n]) == false) {
                // array contendo apenas ID de quem será removido
                this.arrayAcao.push(this.arrayAnterior[n])
              }
            }
            this.deletarExecucao(IdAgendamentoServico)

          } else if (this.arrayAnterior.length < this.selectedAuxiliar.length && this.arrayRemocao.length == 0) {
            // metodo para cadastrar select-all e single-select
            for (var j = 0; j < this.selected.length; j++) {
              if (this.arrayAnterior.includes(this.selected[j].IdCliente) == false) {
                // array contendo dados de quem será inseridoh8
                this.arrayAcao.push(
                    {
                      IdCliente: this.selected[j].IdCliente,
                      IdTipoCliente: this.selected[j].IdTipoCliente
                    }
                )
              }
              //se array anterior != array atual, cadastre se array atual > array anterior
            }
            this.cadastrar(IdAgendamentoServico)
          }
        } else {
          if (this.selected.length > this.funcionariosRegistrados.length && this.selected.length>0 && this.funcionariosRegistrados.length < 1) {
            // só entra nesse IF APENAS no cenário que ainda não há certificações e usuário fez select-all
            for (i = 0; i < this.selected.length; i++) {
              this.arrayAcao.push({
                IdCliente: this.selected[i].IdCliente,
                IdTipoCliente: this.selected[i].IdTipoCliente
              })
            }
            this.cadastrar(IdAgendamentoServico)
            this.funcionariosRegistrados = 10
          }
        }
        // arrayRemocao é populado apenas quando checkbox removeall é ativa
        if (this.arrayAnterior.length > this.selected.length && this.arrayRemocao.length > 0) {
          let con = confirm("Deseja realmente remover todos os participantes registrados?")
          if (con) {
            this.deletarExecucao(IdAgendamentoServico)
          }else{
            this.getFuncionarios()
          }
        }
        this.arrayAcao = []
        this.arrayAnterior = []
        this.arrayRemocao = []
        this.selectedAuxiliar = []
        this.arrayRemocaoClientes = []
      }
    },
    singleSelected(){
      for(var i = 0; i < this.selected.length; i++){
        this.arrayAnterior.push(this.selected[i].IdCliente)
      }
      //remover elementos duplicados
      this.arrayAnterior = this.arrayAnterior.filter((este, i) => this.arrayAnterior.indexOf(este) === i);
    },
    cadastrar(IdAgendamentoServico) {
      this.showSelect = false
      this.loadTable = true
      //cadastro funciona da mesma maneira para cadastrar um ou todos
      let formData = new FormData();
      formData.append('IdAgendamentoServico', IdAgendamentoServico);
      // funcionarios
      for (let i = 0; i < this.arrayAcao.length; i++) {
        formData.append(`funcionarios[${i}][IdCliente]`, this.arrayAcao[i].IdCliente);
        formData.append(`funcionarios[${i}][IdTipoCliente]`, this.arrayAcao[i].IdTipoCliente);
      }
      this.axios.post('execucoes',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(res => {
            this.system.snackbar = {
              snackbar: true,
              text: res.data,
              color: "green",
            };
          })
          .catch(error => {
            // clearInterval
            this.system.snackbar = {
              snackbar: true,
              text: error.response.data,
              color: "red",
            };
          }).finally(() => {
        this.getFuncionarios()
      })
    },
    OneUserToService(item, user) {
      this.axios.post(`execucoes/${user.IdCliente}/tipo/${user.IdTipoCliente}/to/${item.IdAgendamentoServico}`).then((res) => {
        this.system.snackbar = {
          snackbar: true,
          text: res.data,
          color: "green",
        };
      }).catch(error => {
        // clearInterval
        this.system.snackbar = {
          snackbar: true,
          text: error.response.data,
          color: "red",
        };
      }).finally(() => {
        this.getFuncionarios()
      })
    },
    OneUserAllServices(user){
      this.axios.post(`execucoes/${user.IdCliente}/tipo/${user.IdTipoCliente}/all/${this.IdAgendamento}`).then((res) => {
        this.system.snackbar = {
          snackbar: true,
          text: res.data,
          color: "green",
        };
      }).catch(error => {
        // clearInterval
        this.system.snackbar = {
          snackbar: true,
          text: error.response.data,
          color: "red",
        };
      }).finally(() => {
        this.getFuncionarios()
      })
    },
    deletarExecucao(IdAgendamentoServico){
      //remover apenas uma pessoa
      if(this.arrayRemocao.length == 0) {
        this.axios.delete(`execucoes/${IdAgendamentoServico}/servicos`, {
          params: {
            IdCliente: this.arrayAcao[0]
          }})
            .then(res => {
              this.system.snackbar = {
                snackbar: true,
                text: res.data,
                color: "green",
              };
            }).catch(error => {
          // clearInterval
          this.system.snackbar = {
            snackbar: true,
            text: error.response.data,
            color: "red",
          };
        }).finally(() => {
          this.getFuncionarios()
        })
      }else{
        // remover todos funcionarios
        for (let i = 0; i < this.arrayRemocao.length; i++) {
          this.arrayRemocaoClientes.push(this.arrayRemocao[i].IdCliente);
        }
        this.axios.delete(`execucoes/${IdAgendamentoServico}/servicos`, {
          params: {
            arrayRemocaoClientes: this.arrayRemocaoClientes
          }
        }).then(res => {
          this.system.snackbar = {
            snackbar: true,
            text: res.data,
            color: "green",
          };
        }).catch(error => {
          this.system.snackbar = {
            snackbar: true,
            text: error.response.data,
            color: "red",
          };
        }).finally(() => {
          this.getFuncionarios()
        })
      }
    },
    anexarArquivos(IdAgendamentoServico){
      let formData = new FormData();
      formData.append('IdAgendamentoServico', IdAgendamentoServico);
      formData.append('anexosTipo', this.anexosTipo)
      // anexos
      if (this.files) {
        for(let i = 0; i < this.files.length; i++){
          let file = this.files[i];
          formData.append(`files[${i}]`, file);
        }
      }
      this.loadAnexos = true
      this.axios.post('execucoes/files',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(res => {
            //202: Campos e requisiçoes vazias
            if (res.status == 202) {
              this.system.snackbar = {
                snackbar: true,
                text: res.data,
                color: "red",
              };
            }else{
                this.system.snackbar = {
                  snackbar: true,
                  text: res.data,
                  color: "green",
                };
              }
          })
          .catch(error => {
            this.system.alertInfo = error.response.data
            this.system.alertError = true
          }).finally(() => {
        this.loadAnexos = false
      })
    },
    // metodo antigo, não será mais usado
    deletar(IdAgendamentoExecucao) {
      let con = confirm("Deseja realmente remover esse funcionário?")
      if (con) {
        this.axios
            .delete(`execucoes/${IdAgendamentoExecucao}`)
            .then(res => {
              this.system.snackbar = {
                snackbar: true,
                text: res.data,
                color: "green",
              };
            })
            .catch(error => {
              // clearInterval
              this.system.snackbar = {
                snackbar: true,
                text: error.response.data,
                color: "red",
              };
            }).finally(() => {
          this.getServicos(this.reloadIdAgendamento)
          this.tab = null
        })
      }
    },
    updateStatus(IdAgendamento) {
      this.axios.get(`agendamentos/${IdAgendamento}`).then(res => {
        this.statusAgendamento = res.data[0].status
        if(this.statusAgendamento == true){
          let upd = confirm('Deseja fechar esse agendamento?')
          if(upd) {
            this.axios.put(`agendamentos/${IdAgendamento}/status`).then(()=> {
              this.statusAgendamento = null
              this.getAgendamentos ()
            }).catch((e) => {
              this.system.snackbar = {
                snackbar: true,
                text: e.response,
                color: "red",
              };
            })
          }
        }else{
          let upd = confirm('Deseja reabrir esse agendamento?')
          if(upd) {
            this.axios.put(`agendamentos/${IdAgendamento}/status`).then(() => {
              this.statusAgendamento = null
              this.getAgendamentos ()
            })
          }
        }
      })
    },
    getstatusProcessos(){
      this.axios.get(`agendamentos/statusProcesso`)
      .then(res=>{
        this.ProcessoList = res.data;
      })
    },
    fecharModal(){
      this.getAgendamentos()
      this.servicos = null
      this.tab = null
      this.dadosEmpresa = null
    },
    gerarRelatorio () {
      this.loadRelatorio = true
      this.myloadingvariable = true

      this.axios(`servicos/relatorio?de=${this.dataInicialRelatorio}&ate=${this.dataFinalRelatorio}`, {
        params:{
          IdUnidade:      this.IdUnidade,
          IdEmpresa:      this.IdEmpresa,
          IdCredenciado:  this.IdCredenciado,
          IdEtiqueta:     this.TipoFiltro,
          IdProcesso:     this.IdProcesso
        },
        responseType: 'arraybuffer',
      }).then( ( res ) => {
        var blob = new Blob([res.data], {
          type: 'application/pdf'
        });
        var url = window.URL.createObjectURL(blob)
        window.open(url);
      }).finally( () => {
        this.loadRelatorio = false
        this.myloadingvariable = false
        this.modalPeriodoRelatorioServico = false
      })
    },
    getEmpresasFilter(){
        this.axios('empresas/calendario').then(res=>{
          this.empresasFilter = res.data
        })
      },
    getCredenciadosFiler(){
      this.axios('credenciados/calendario').then(res=>{
        this.credenciadosFilter = res.data
      })
    },
    limparFiltros(){
      this.IdUnidade        = null
      this.IdEmpresa        = null
      this.IdCredenciado    = null
      this.IdMes            = null
      this.IdAno            = moment().format('YYYY')
      this.IdProcesso       = null
      this.TipoFiltro       = null
      this.getAgendamentos()
    }
  },
  mounted() {
    this.IdCredenciado = JSON.parse(sessionStorage.getItem('IdProfissional'))
    this.getAgendamentos()
    this.getUnidades()
    this.getEtiquetas()
    this.getstatusProcessos()
    this.getEmpresasFilter()
    if(!this.IdCredenciado) this.getCredenciadosFiler()
  }
};
</script>
